export default {
  400: {
    description: "Bad Request",
    redirectTo: null,
  },
  401: {
    description: "invalid tokens",
    redirectTo: null,
  },
  403: {
    description: "forbidden, when user tries to access unauthorized routes",
    redirectTo: "home-page",
    rollbarTracking: true,
  },
  404: {
    description: "not found",
    redirectTo: "not-found",
    rollbarTracking: true,
  },
  500: {
    description: "server error",
    redirectTo: null,
    rollbarTracking: true,
  },
  503: {
    description: "maintenance mode",
    redirectTo: null,
  },
  409: {
    description: "user already registered",
    redirectTo: "login",
  },
  422: {
    description: "validation error",
    redirectTo: null,
  },
  406: {
    description: "validation error",
    redirectTo: null,
  },
  451: {
    description: "Unavailable For Legal Reasons", // suspension || request account deletion
    redirectTo: "system-unreachable",
  },
  412: {
    description: "No available payouts and revenue",
    redirectTo: null,
  },
}
